export const MAIN_FRAME_SLOT_ID = '__main_frame__'
export const MAIN_FRAME_PAGE_FLAG = '$isMainFrame'
export const MAIN_FRAME_STARTUP_FLAG = 'isStartupMainFrame'
/** Same key as startupAction.service STARTUP_ACTION_DIALOG_FLAG */
export const STARTUP_ACTION_FLAG = 'isStartupAction'

export function isMainFrameSlot(id: unknown): boolean {
  return String(id ?? '').trim() === MAIN_FRAME_SLOT_ID
}

export function isMainFramePageData(data: unknown): boolean {
  if (data == null || typeof data !== 'object') return false
  return (data as Record<string, unknown>)[MAIN_FRAME_PAGE_FLAG] === true
}

export function isStartupMainFramePageData(data: unknown): boolean {
  if (!isMainFramePageData(data)) return false
  const record = data as Record<string, unknown>
  return (
    record[MAIN_FRAME_STARTUP_FLAG] === true ||
    record[STARTUP_ACTION_FLAG] === true
  )
}

export function resolveMainFramePageSlotId(_openedFormId?: string): string {
  return MAIN_FRAME_SLOT_ID
}

export function stampMainFramePageData(
  data: Record<string, unknown>,
  options?: { isStartupAction?: boolean },
): Record<string, unknown> {
  const stamped = { ...data }
  stamped[MAIN_FRAME_PAGE_FLAG] = true
  stamped.$isDialog = false
  if (options?.isStartupAction) {
    stamped[MAIN_FRAME_STARTUP_FLAG] = true
    stamped[STARTUP_ACTION_FLAG] = true
  }
  return stamped
}
